export default __webpack_public_path__ + "static/media/teamBen.457a0139.jpg";